import axios from 'axios';

export interface ILatestBuilds {
  [tenantId: string]: {
    latest: { [platform: string]: string }; // Version
    tenantId: string;
  };
}

class CreatorsService {
  baseUrl = process.env.creatorsPublicUrl;
  async getLatestBuilds(): Promise<ILatestBuilds> {
    try {
      const results = await axios.get(
        `${this.baseUrl}/builds/${process.env.creatorsEnv}/latest`,
      );
      return results.data;
    } catch (err) {
      throw new Error(err);
    }
  }
}

export default new CreatorsService();
